import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'qs';

import { getInstrumentAction } from 'store/instrument/instrumentActions';
import {
  companyInstrumentModules as companyModulesConst,
  companyInstrumentTabs,
} from 'shared/constants/company';
import { Loader } from 'ui';
import { InstrumentContent } from './InstrumentContent';

const Instrument = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { instrumentId } = useParams();
  const [activeTabs, setActiveTabs] = useState({
    companyModule: companyModulesConst[0].value,
    companyTab: companyInstrumentTabs[0].value,
  });

  const instrument = useSelector(state => state.instrument);
  const { data, shouldRefresh, isRatingRequestPending, isPending } = instrument;

  const getInstrument = () => dispatch(getInstrumentAction({ id: instrumentId }));

  useEffect(() => {
    getInstrument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instrumentId]);

  useEffect(() => {
    if (shouldRefresh) {
      getInstrument();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRefresh]);

  useEffect(() => {
    const { companyTab, companyModule } = qs.parse(location.search, { ignoreQueryPrefix: true });

    if (companyInstrumentTabs.map(({ value }) => value).includes(companyTab)) {
      setActiveTabs(currentValues => ({ ...currentValues, companyTab }));
    }

    if (companyModulesConst.map(({ value }) => value).includes(companyModule)) {
      setActiveTabs(currentValues => ({ ...currentValues, companyModule }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) return <Loader />;

  return (
    <InstrumentContent
      activeTabs={activeTabs}
      setActiveTabs={setActiveTabs}
      data={data}
      instrumentId={instrumentId}
      isRatingRequestPending={isRatingRequestPending}
      isPending={isPending}
    />
  );
};

export { Instrument };
